/**
 * Main page implementation.
 *
 * @author Stanislav Kalashnik <sk@infomir.eu>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 */

'use strict';

var id            = 'pageMore',
    app           = require('mag-app'),
    Page          = require('stb-component-page'),
    page          = new Page({$node: document.getElementById(id)}),
    ScrollArea    = require('mag-component-scroll-area'),
    Scroll        = require('stb-component-scrollbar'),
    PanelSet      = require('mag-component-panel-set'),
    PanelExtended = require('mag-component-panel'),
    Button        = require('stb-component-button'),
    Flicker       = require('spa-component-flicker'),
    keys          = require('stb-keys');

window.mpage = page;

page.clock = new Flicker({
    className: 'clock',
    interval: 1000,
    render: function ( $item ) {
        var time  = new Date(),
            hours = time.getHours(),
            mins  = time.getMinutes();

        $item.innerText = (hours > 9 ? hours : '0' + hours) + ':' + (mins > 9 ? mins : '0' + mins);
    }
});
page.add(page.clock);
page.clock.start();

page.panelDetails = new PanelExtended({
    main: true, visible: true, className: 'panelDetails', children: [], title: '_'
});
page.panelDetails.reset = function ( data ) {
    page.panelDetails.$title.$node.innerText = data.title;
    page.panelDetails.scroll.init({value: 0});
    page.panelDetails.area.$body.innerText = data.value;
    page.panelDetails.area.$body.style.top = '0px';
    page.panelDetails.area.init();
    page.panelDetails.focus();
    if ( page.panelDetails.scroll.viewSize < page.panelDetails.scroll.realSize ) {
        page.panelDetails.area.focus();
    } else {
        page.panelDetails.button.focus();
    }
};

page.panelDetails.button = new Button({
    value: gettext('Close'),
    className: 'bottom theme-footer',
    $node: page.panelDetails.$node.appendChild(document.createElement('div')),
    events: {
        click: function () { app.route(app.pages.info); },
        keydown: function ( event ) {
            if ( event.code === keys.up && page.panelDetails.scroll.viewSize < page.panelDetails.scroll.realSize ) {
                page.panelDetails.area.focus();
            } else if ( event.code === keys.ok ) {
                if ( page.panelDetails.button.events['click'] ) {
                    page.panelDetails.button.emit('click', {event: event});
                }
            }
        }
    }
});
page.panelDetails.add(page.panelDetails.button);

page.panelDetails.scroll = new Scroll({});
page.panelDetails.area = new ScrollArea({
    visible: true,
    scroll: page.panelDetails.scroll,
    events: {
        overflow: function ( data ) {
            if ( data.direction === keys.down ) {
                page.panelDetails.area.blur();
                page.panelDetails.button.focus();
            }
        }
    }
});
page.panelDetails.add(page.panelDetails.area, page.panelDetails.scroll);

// panel set: download details
page.panelSet = new PanelSet({
    visible: false,
    $node: document.getElementById('panelSetMore'),
    focusIndex: 0,
    panels: [page.panelDetails]
});
page.add(page.panelSet);

page.addListener('keydown', function ( event ) {
    switch ( event.code ) {
        case keys.back:
            app.route(app.pages.info);
            break;
    }
});

page.addListener('show', function ( data ) {
    page.panelSet.show();
    page.panelDetails.reset({
        title: data.data.$item.data.items[0].value,
        value: data.data.$item.data.items[1].value
    });
});


// public
module.exports = page;
